import { render, staticRenderFns } from "./MoveArrow.vue?vue&type=template&id=8f0852ce&scoped=true"
import script from "./MoveArrow.vue?vue&type=script&lang=js"
export * from "./MoveArrow.vue?vue&type=script&lang=js"
import style0 from "./MoveArrow.vue?vue&type=style&index=0&id=8f0852ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0852ce",
  null
  
)

export default component.exports